import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  TemplateRef,
  contentChildren,
  effect,
  input,
  output,
  signal,
  viewChildren,
} from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatIcon } from '@angular/material/icon';
import { TabComponent } from '../tab/tab.component';
import { ButtonComponent } from '@dss-libs/shared/ui/common-components';

@Component({
  selector: 'dss-libs-ui-tabs-group',
  imports: [TranslocoDirective, NgTemplateOutlet, MatIcon, ButtonComponent],
  templateUrl: './tabs-group.component.html',
  styleUrl: './tabs-group.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabsGroupComponent {
  // When using this component, wrap each tab content inside 'dss-libs-ui-tab'
  readonly tabs = contentChildren(TabComponent);
  readonly tabElements = viewChildren<ElementRef<HTMLLIElement>>('tabItem');
  readonly mainContainerClasses = input('');
  readonly tabsContainerClasses = input('');
  readonly isSubmitButtonEnabled = input(false);
  readonly alwaysShowSubmit = input(false);
  readonly tabIndexWithValidationError = input<number>();
  readonly discardTriggered = output();
  selectedIndex = signal(0);

  private readonly _selectValidationErrorTabEffect = effect(() => {
    this.selectTab(this.tabIndexWithValidationError() ?? 0);
  });

  selectTab(index: number): void {
    this.selectedIndex.set(index);
  }

  getTabTemplateByIndex(index: number): TemplateRef<any> | undefined {
    return this.tabs()?.[index]?.template();
  }

  selectNextTab(): void {
    if (!this.isLastTab()) {
      this.selectedIndex.update((i) => i + 1);
    }
  }

  isLastTab(): boolean | undefined {
    const tabs = this.tabs();
    return !tabs || this.selectedIndex() >= tabs?.length - 1;
  }

  onDiscardClick(): void {
    this.discardTriggered.emit();
  }
}
